import {Request, RequestOptionsArgs, Response, Headers, Http, RequestOptions} from "@angular/http";
import {Observable} from "rxjs/Rx";
import {LocaleService} from "../components/language-picker/locale.service";
import {AuthConfig, AuthHttp} from "angular2-jwt";

export class MyHttp extends AuthHttp {
  constructor(private locale: LocaleService,
              config: AuthConfig,
              http: Http,
              options?: RequestOptions) {
    super(config, http, options);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    options = this.setLang(options);
    return super.request(url, options)
  }

  setLang(opts) {
    opts = opts || {};
    if (!opts.headers) {
      opts.headers = new Headers();
    }
    if (!opts.headers.has('Language')) {
      opts.headers.set('Language', this.locale.getLocale());
    }
    return opts;
  }

}




// WEBPACK FOOTER //
// ./src/app/core/http.ts